import e from "react";
import { Route as t } from "react-router-dom";
import { Fragment as n, jsx as r } from "react/jsx-runtime";
//#region src/TopRoute.tsx
var i = ({ children: i, fallback: a, ...o }) => {
	let s = /* @__PURE__ */ r(t, {
		...o,
		render: () => /* @__PURE__ */ r(n, { children: i })
	});
	return a === void 0 ? s : /* @__PURE__ */ r(e.Suspense, {
		fallback: a,
		children: s
	});
};
//#endregion
export { i as TopRoute };
